var initRecursive = function (obj, path) {
    return function () {
        var keys = Object.keys(obj);

        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            if (obj.hasOwnProperty(key)) {
                var val = obj[key];

                if (key.toLowerCase() === 'init' && path !== 'ICF.Utils' && val.length === 0) {
                    try {
                        val();
                    } catch (err) {
                        console.error(err);
                    }
                }

                if (val != null && typeof val === 'object') {
                    initRecursive(val, path + '.' + key)();
                }
            }
        }
    };
};

$(document).ready(function () {
    initRecursive(ICF, 'ICF')();
    window.ICFInitiated = true;
});
